// import React, { createContext, useContext, useEffect, useState } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [accessToken, setAccessToken] = useState(Cookies.get("access_token") || null);
//   const [refreshToken, setRefreshToken] = useState(Cookies.get("refresh_token") || null);
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);
//   const [authError, setAuthError] = useState(null);

//   const login = async (email, password) => {
//     setIsLoading(true);
//     setAuthError(null);

//     try {
//       const response = await axios.post(
//         "https://admin.thirsty-shtern.91-151-16-181.plesk.page/auth/login",
//         { email, password }
//       );

//       const { access_token, refresh_token } = response.data.data;

//       // Сохраняем токены в cookies
//       Cookies.set("access_token", access_token, { expires: 1 / 24 }); // срок действия 1 час
//       Cookies.set("refresh_token", refresh_token, { expires: 7 }); // срок действия 7 дней

//       setAccessToken(access_token);
//       setRefreshToken(refresh_token);

//       await fetchUser(access_token);
//     } catch (error) {
//       console.error("Ошибка входа:", error);
//       setAuthError("Не удалось войти – пожалуйста, проверьте свои данные.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const logout = () => {
//     Cookies.remove("access_token");
//     Cookies.remove("refresh_token");
//     setAccessToken(null);
//     setRefreshToken(null);
//     setUser(null);
//   };

//   const fetchUser = async (token) => {
//     try {
//       const res = await axios.get(
//         "https://admin.thirsty-shtern.91-151-16-181.plesk.page/users/me",
//         {
//           headers: {
//             Authorization: `Bearer ${token || accessToken}`,
//           },
//         }
//       );
//       setUser(res.data.data);
//     } catch (error) {
//       console.error("❌ Fehler beim Abrufen des Benutzers:", error);
//       logout();
//     }
//   };

//   const refresh = async () => {
//     try {
//       const response = await axios.post(
//         "https://admin.thirsty-shtern.91-151-16-181.plesk.page/auth/refresh",
//         { refresh_token: refreshToken }
//       );

//       const { access_token } = response.data.data;
//       Cookies.set("access_token", access_token, { expires: 1 / 24 });
//       setAccessToken(access_token);
//     } catch (err) {
//       logout();
//     }
//   };

//   useEffect(() => {
//     if (accessToken) {
//       fetchUser(accessToken);
//     } else {
//       setLoading(false);
//     }
//   }, [accessToken]);

//   return (
//     <AuthContext.Provider
//       value={{
//         accessToken,
//         refreshToken,
//         user,
//         login,
//         logout,
//         refresh,
//         loading,
//         isLoading,
//         authError,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

// // src/contexts/AuthContext.jsx
// import React, { createContext, useContext, useEffect, useState } from "react";
// import axios from "axios";
// import Cookies from "js-cookie";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [accessToken, setAccessToken] = useState(Cookies.get("access_token") || null);
//   const [refreshToken, setRefreshToken] = useState(Cookies.get("refresh_token") || null);
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isLoading, setIsLoading] = useState(false);
//   const [authError, setAuthError] = useState(null);

//   const login = async (email, password) => {
//     setIsLoading(true);
//     setAuthError(null);

//     try {
//       const response = await axios.post(
//         "https://admin.thirsty-shtern.91-151-16-181.plesk.page/auth/login",
//         { email, password }
//       );

//       const { access_token, refresh_token } = response.data.data;

//       // Сохраняем токены в cookies
//       Cookies.set("access_token", access_token, { expires: 1 / 24 }); // 1 час
//       Cookies.set("refresh_token", refresh_token, { expires: 7 }); // 7 дней

//       setAccessToken(access_token);
//       setRefreshToken(refresh_token);

//       await fetchUser(access_token);
//     } catch (error) {
//       console.error("Ошибка входа:", error);
//       setAuthError("Не удалось войти – пожалуйста, проверьте свои данные.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const logout = () => {
//     Cookies.remove("access_token");
//     Cookies.remove("refresh_token");
//     setAccessToken(null);
//     setRefreshToken(null);
//     setUser(null);
//   };

//   const fetchUser = async (token) => {
//     try {
//       const res = await axios.get(
//         "https://admin.thirsty-shtern.91-151-16-181.plesk.page/users/me",
//         {
//           headers: {
//             Authorization: `Bearer ${token || accessToken}`,
//           },
//         }
//       );
//       setUser(res.data.data);
//     } catch (error) {
//       console.error("❌ Fehler beim Abrufen des Benutzers:", error);
//       logout();
//     } finally {
//       setLoading(false); // ← обязательно!
//     }
//   };

//   const refresh = async () => {
//     try {
//       const response = await axios.post(
//         "https://admin.thirsty-shtern.91-151-16-181.plesk.page/auth/refresh",
//         { refresh_token: refreshToken }
//       );

//       const { access_token } = response.data.data;
//       Cookies.set("access_token", access_token, { expires: 1 / 24 });
//       setAccessToken(access_token);
//     } catch (err) {
//       logout();
//     }
//   };

//   useEffect(() => {
//     if (accessToken) {
//       fetchUser(accessToken);
//     } else {
//       setLoading(false);
//     }
//   }, [accessToken]);

//   return (
//     <AuthContext.Provider
//       value={{
//         accessToken,
//         refreshToken,
//         user,
//         login,
//         logout,
//         refresh,
//         loading,
//         isLoading,
//         authError,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

// src/contexts/AuthContext.jsx
import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(
    Cookies.get("access_token") || null
  );
  const [refreshToken, setRefreshToken] = useState(
    Cookies.get("refresh_token") || null
  );
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [authError, setAuthError] = useState(null);

  const login = async (email, password) => {
    setIsLoading(true);
    setAuthError(null);

    try {
      const response = await axios.post(
        "https://admin.thirsty-shtern.91-151-16-181.plesk.page/auth/login",
        { email, password }
      );

      const { access_token, refresh_token, expires } = response.data.data;

      const accessTokenExpiresAt = new Date(Date.now() + expires);

      Cookies.set("access_token", access_token, {
        expires: accessTokenExpiresAt,
      });
      Cookies.set("refresh_token", refresh_token, { expires: 7 });

      setAccessToken(access_token);
      setRefreshToken(refresh_token);

      await fetchUser(access_token);
    } catch (error) {
      console.error("Error:", error);
      setAuthError("Anmeldung fehlgeschlagen – bitte überprüfen Sie Ihre Angaben.");
    } finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    setAccessToken(null);
    setRefreshToken(null);
    setUser(null);
  };

  const fetchUser = async (token) => {
    try {
      const res = await axios.get(
        "https://admin.thirsty-shtern.91-151-16-181.plesk.page/users/me",
        {
          headers: {
            Authorization: `Bearer ${token || accessToken}`,
          },
        }
      );
      setUser(res.data.data);
    } catch (error) {
      console.error("❌ Fehler beim Abrufen des Benutzers:", error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  // const refresh = async () => {
  //   try {
  //     const response = await axios.post(
  //       "https://admin.thirsty-shtern.91-151-16-181.plesk.page/auth/refresh",
  //       { refresh_token: refreshToken }
  //     );

  //     const { access_token, expires } = response.data.data;
  //     const accessTokenExpiresAt = new Date(Date.now() + expires);

  //     Cookies.set("access_token", access_token, {
  //       expires: accessTokenExpiresAt,
  //     });
  //     setAccessToken(access_token);
  //   } catch (err) {
  //     console.error("Ошибка обновления токена:", err);
  //     logout();
  //   }
  // };

  const refresh = async () => {
    if (!refreshToken) {
      logout();
      return;
    }
    try {
      const response = await axios.post(
        "https://…/auth/refresh",
        { refresh_token: refreshToken },
        { withCredentials: true }
      );

      const {
        access_token: newAccess,
        refresh_token: newRefresh,
        expires,
      } = response.data.data;

      const accessTokenExpiresAt = new Date(Date.now() + expires);

      // Перезаписываем оба токена
      Cookies.set("access_token", newAccess, {
        expires: accessTokenExpiresAt,
        secure: true,
        sameSite: "Lax",
      });
      Cookies.set("refresh_token", newRefresh, {
        expires: 7, // или ваш срок
        secure: true,
        sameSite: "Lax",
      });

      setAccessToken(newAccess);
      setRefreshToken(newRefresh);
    } catch (err) {
      console.error("Ошибка обновления токена:", err.response?.data || err);
      logout();
    }
  };

  // ⏳ Automatische Token-Aktualisierung alle 14 Minuten
  useEffect(() => {
    if (!refreshToken) return;

    const interval = setInterval(() => {
      refresh();
    }, 14 * 60 * 1000); // 14 min

    return () => clearInterval(interval);
  }, [refreshToken]);

  // 🚀 Benutzerabruf beim Start
  useEffect(() => {
    if (accessToken) {
      fetchUser(accessToken);
    } else {
      setLoading(false);
    }
  }, [accessToken]);

  // 🔁 Axios-Interceptor — Abfangen von 401-Fehlern
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;

        if (
          error.response?.status === 401 &&
          !originalRequest._retry &&
          refreshToken
        ) {
          originalRequest._retry = true;

          try {
            await refresh();
            const newAccessToken = Cookies.get("access_token");

            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            return axios(originalRequest);
          } catch (err) {
            console.error("Fehler beim Aktualisieren des Tokens:", err);
            alert(
              "⚠️ Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an."
            );
            logout();
          }
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [refreshToken]);

  return (
    <AuthContext.Provider
      value={{
        accessToken,
        refreshToken,
        user,
        login,
        logout,
        refresh,
        loading,
        isLoading,
        authError,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
